export default {
    CONSTITUTION: 'CONSTITUTION',
    APPOINTMENT: 'APPOINTMENT',
    OWNERSHIP: 'OWNERSHIP',
  };
  